export default __webpack_public_path__ + "static/media/Naveed.1dac6a9d.png";